export * from "./DisplayProperties";
export { default } from "./DisplayProperties";
